export default __webpack_public_path__ + "static/image_restauration_s-53e5e4baf7251acbb138e4a9e71134c3.jpg";